// extracted by mini-css-extract-plugin
export default {"primaryButton":"ToolsPage_primaryButton__3UToB","pageContainer":"ToolsPage_pageContainer__Ourww","buttonWithImage":"ToolsPage_buttonWithImage__sHVkD"};